import { caption } from '../../styles/commonStyles';
import { createStyles, makeStyles } from '@mui/styles';
import clsx from 'clsx';
import { Colors } from 'copyright-clearance-center-common-ui';

const useStyles = makeStyles(() =>
	createStyles({
		root: {
			display: 'flex',
			gap: '0.5rem'
		},
		text: {
			...caption,
			flex: '1 0 0'
		},
		lozenge: {
			background: Colors.secondary100,
			color: Colors.secondary900
		}
	})
);

interface IGenreLozengeProps {
	genre: string;
	parentTitle?: string;
}

const GenreLozenge: React.FunctionComponent<IGenreLozengeProps> = props => {
	const classes = useStyles();

	return (
		<div className={classes.root}>
			<div>
				<span className={clsx('rup-lozenge', classes.lozenge)}>{props.genre}</span>
			</div>
			{props.parentTitle && <div className={classes.text}>{props.parentTitle}</div>}
		</div>
	);
};

export default GenreLozenge;
